import { __assign } from "tslib";
import * as React from 'react';
export * from './ReactEmbed';
var Resource = React.lazy(function () {
  return import('./ReactEmbed');
});
var Embed = function Embed(props) {
  return React.createElement(React.Suspense, {
    fallback: props.fallback || null
  }, React.createElement(Resource, __assign({}, props)));
};
export default Embed;